module.exports = __webpack_public_path__ + "img/qr-code-gema-mgv.de.5972b12b.png";